import React from "react";
import { motion } from "framer-motion";

const CHAPTERS = [
  {
    n: "01",
    title: "Source Anything, From Anywhere",
    body: "Pipe, valves and fittings to gaskets, stud bolts, blinds, hardware, plywood and lumber — if a jobsite needs it, we track it down. One partner for the entire bill of materials.",
  },
  {
    n: "02",
    title: "Built For Contractors",
    body: "We understand submittals, spec sheets and deadlines. Quotes come back fast and accurate, so your crews stay moving and your bids stay competitive.",
  },
  {
    n: "03",
    title: "Right Spec, Every Time",
    body: "Material grades, pressure classes, coatings and certifications matter. We verify against your requirements before anything ships — no guesswork, no rework.",
  },
  {
    n: "04",
    title: "Delivered On Schedule",
    body: "Coordinated logistics and expediting keep your material flowing to the jobsite when the schedule demands it, whether it's a single line item or a full package.",
  },
];

const reveal = {
  hidden: { opacity: 0, y: 28 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: i * 0.08 } }),
};

export const Manifesto = () => {
  return (
    <section id="approach" className="relative py-24 md:py-36 bg-background" data-testid="manifesto">
      <div className="max-w-[1500px] mx-auto px-5 md:px-10">
        <div className="mb-16 md:mb-24 max-w-3xl">
          <span className="font-mono-tech text-xs tracking-[0.3em] uppercase text-primary flex items-center gap-3">
            <span className="inline-block w-10 h-px bg-accent" /> The Approach
          </span>
          <h2 className="font-display font-extrabold uppercase tracking-tight text-4xl md:text-6xl mt-6 leading-[0.95] text-foreground">
            How we keep your procurement anchored
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-x-16 gap-y-14">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.n}
              custom={i}
              variants={reveal}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-80px" }}
              className="group border-t border-border pt-7 flex gap-6"
              data-testid={`chapter-${c.n}`}
            >
              <span className="font-mono-tech text-sm text-accent shrink-0 pt-2">{c.n}</span>
              <div>
                <h3 className="font-display font-bold text-2xl md:text-3xl tracking-tight text-foreground group-hover:text-primary transition-colors duration-300">
                  {c.title}
                </h3>
                <p className="mt-4 text-base md:text-lg text-steel leading-relaxed">{c.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
